import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20inviting%20retail%20boutique%20interior%20with%20terracotta%20walls%20wooden%20floating%20shelves%20displaying%20curated%20fashion%20pieces%20in%20earthy%20tones%20cascading%20indoor%20plants%20soft%20pendant%20lighting%20creating%20gentle%20pools%20of%20light%20midcentury%20modern%20fixtures%20editorial%20interior%20photography%20sophisticated%20warm%20atmosphere&width=1800&height=1200&seq=hero-bg-superbuy-v2&orientation=landscape"
          alt="Superbuy Spreadsheet - Organized product discovery hub featuring curated fashion items in a warm boutique setting"
          title="Superbuy Spreadsheet Resources"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 md:px-6 text-center pt-16">
        <div className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full border border-background-50/30 bg-background-50/10 backdrop-blur-sm mb-6">
          <i className="ri-sparkling-line text-background-50 text-xs"></i>
          <span className="text-background-50/90 text-xs font-medium tracking-wide">Updated 2026 Resources</span>
        </div>

        <h1 className="font-heading text-5xl md:text-7xl lg:text-[80px] font-semibold text-background-50 leading-[1.1] tracking-tight mb-6">
          Superbuy Spreadsheet
        </h1>

        <p className="text-background-50/85 text-base md:text-lg max-w-[650px] mx-auto leading-relaxed mb-10">
          Your smarter way to discover products from China. Access organized Superbuy Spreadsheet resources, product collections, shopping guides and expert tips designed to help international buyers research products faster and make better purchasing decisions.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Explore Superbuy Spreadsheet
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 border border-background-50/40 text-background-50 text-sm font-semibold rounded-full hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
          >
            Visit Main Website
            <i className="ri-external-link-line"></i>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 text-background-50/70 text-xs">
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Updated Resources
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Beginner Friendly
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Shopping Guides
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-400"></i>
            Safety Information
          </span>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/50 text-2xl"></i>
      </div>
    </section>
  );
}